<app-vvr-icon [dark]="false" [full]="false" [overlay]="false" [shadow]="false"></app-vvr-icon>
<div class="container">
    <div class="topbar">
        <div class="title">
            <h1 class="h3 condensed">Klanten</h1>
        </div>
        <div class="controls">
            <div
                class="fab small"
                id="btn-Exit"
                matTooltip="Terug naar startscherm"
                matTooltipPosition="below"
                routerLink="/">
                <i class="fas fa-sign-out-alt"></i>
            </div>
            <div
                class="fab small"
                matTooltip="Werk in de buurt"
                matTooltipPosition="below"
                routerLink="/pushpins/map/nearby/14/52/4.8">
                <i class="fa-solid fa-location-arrow"></i>
            </div>
            @if (AuthorisationService.hasFeature('importUpload')) {
                <div
                    class="fab small"
                    id="btn-import"
                    matTooltip="Importeren"
                    matTooltipPosition="below"
                    routerLink="/import">
                    <i class="fas fa-file-import"></i>
                </div>
            }
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-md-4">
            @if (customers()?.length) {
                @if (!selectedCustomer()) {
                    <mat-radio-group [formControl]="fcView" aria-label="Toon klanten of gebieden" color="primary">
                        <mat-radio-button class="me-2 mt-3" value="customers">Klanten</mat-radio-button>
                        <mat-radio-button class="mt-3" value="customerAreas">Gebieden</mat-radio-button>
                    </mat-radio-group>
                } @else {
                    <button (click)="deselectCustomer()" class="mt-3" mat-button>
                        Terug naar klanten
                    </button>
                }
            }
        </div>
        <div class="col-md-4">
            <mat-form-field class="me-2 w-100">
                <mat-label>
                    Zoeken
                </mat-label>
                <input
                    (keyup)="searching.emit()"
                    (keyup.enter)="openIfOne()"
                    (ngModelChange)="searchText.set($event)"
                    [ngModel]="searchText()"
                    autocomplete="off"
                    matInput>
            </mat-form-field>
        </div>
        <div class="col-md-4 justify-content-end d-flex">
            @if (AuthorisationService.hasFeature('allCustomerAreas')) {
                <mat-slide-toggle (ngModelChange)="all.set($event); customerAreaService.reset(); getData()" [ngModel]="all()" class="mt-3" color="primary">
                    Toon alle gebieden
                </mat-slide-toggle>
            }
        </div>
    </div>
    @if (fcView.value === 'customers') {
        <div class="customer">
            @for (letterGroup of parsedCustomers(); track letterGroup) {
                <div class="letter-group">
                    <h1 class="h6">{{letterGroup.letter}}</h1>
                    <div class="">
                        @for (customer of letterGroup.customers; track customer) {
                            <div (click)="selectCustomer(customer)" class="customer-area">
                                {{customer.name}}
                                <span>{{customer.count}} {{customer.count > 1 ? 'Gebieden' : 'Gebied'}}</span>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    }
    @if (fcView.value === 'customerAreas') {
        <div class="customer">
            @for (letterGroup of parsedCustomerAreas(); track letterGroup.letter) {
                <div class="letter-group">
                    <h1 class="h6">{{letterGroup.letter}}</h1>
                    <div class="">
                        @for (customerArea of letterGroup.areas; track customerArea) {
                            <div
                                (click)="selectTown(customerArea)"
                                [matBadgeHidden]="customerArea?.calamities?.count < 1"
                                [matBadge]="customerArea?.calamities?.count"
                                class="customer-area"
                                matBadgeColor="{{customerArea.calamities.old ? 'primary' : 'accent'}}"
                                matBadgePosition="after">
                                {{customerArea.name}}
                                <span>{{customerArea.kind}}</span>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    }
    <div class="version-info">{{cordovaVersion()}}</div>
</div>
